import { ChevronLeft } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "1. Acceptance of Terms",
      content:
        "By accessing or using Bite Balance, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our application.",
    },
    {
      title: "2. Description of Service",
      content:
        "Bite Balance is a health and wellness tracking application that provides meal scanning, nutritional analysis, fitness tracking integration, and personalized health insights. The service is intended for informational purposes only and does not constitute medical advice.",
    },
    {
      title: "3. User Accounts",
      content:
        "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must provide accurate and complete information when creating an account.",
    },
    {
      title: "4. User Conduct",
      content:
        "You agree to use Bite Balance only for lawful purposes and in accordance with these Terms. You shall not misuse the service, attempt to gain unauthorized access, or interfere with other users' enjoyment of the application.",
    },
    {
      title: "5. Health Disclaimer",
      content:
        "Bite Balance provides general health and nutrition information. This information is not intended to replace professional medical advice, diagnosis, or treatment. Always consult with a qualified healthcare provider before making changes to your diet or exercise routine.",
    },
    {
      title: "6. Intellectual Property",
      content:
        "All content, features, and functionality of Bite Balance, including but not limited to text, graphics, logos, and software, are the exclusive property of Bite Balance and are protected by copyright, trademark, and other intellectual property laws.",
    },
    {
      title: "7. Data Usage",
      content:
        "By using Bite Balance, you grant us permission to collect and use your health data as described in our Privacy Policy. This data is used to provide personalized recommendations and improve our services.",
    },
    {
      title: "8. Limitation of Liability",
      content:
        "Bite Balance shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.",
    },
    {
      title: "9. Modifications to Terms",
      content:
        "We reserve the right to modify these Terms at any time. We will notify users of significant changes via the application or email. Continued use of the service after changes constitutes acceptance of the new Terms.",
    },
    {
      title: "10. Contact Information",
      content:
        "If you have any questions about these Terms of Service, please contact us at legal@bitebalance.com.",
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-8">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center pt-2">
          <button
            onClick={() => navigate("/profile/about")}
            className="rounded-full p-2 transition-colors hover:bg-muted"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <div className="ml-2">
            <h1 className="text-xl font-bold text-foreground">
              Terms of Service
            </h1>
            <p className="text-xs text-muted-foreground">
              Last updated: December 2025
            </p>
          </div>
        </div>

        {/* Introduction */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <p className="text-sm leading-relaxed text-muted-foreground">
            Welcome to Bite Balance. These Terms of Service govern your use of
            our application and services. Please read them carefully before
            using our app.
          </p>
        </Card>

        {/* Terms Sections */}
        <div className="space-y-3">
          {sections.map((section, index) => (
            <Card key={index} className="rounded-2xl border-0 p-4 shadow-sm">
              <h3 className="mb-2 font-semibold text-foreground">
                {section.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {section.content}
              </p>
            </Card>
          ))}
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground">
          © 2025 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
